import { render, staticRenderFns } from "./e-chips-list.vue?vue&type=template&id=cdf3aaa4&scoped=true&lang=pug&"
import script from "./e-chips-list.vue?vue&type=script&lang=js&"
export * from "./e-chips-list.vue?vue&type=script&lang=js&"
import style0 from "./e-chips-list.vue?vue&type=style&index=0&id=cdf3aaa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf3aaa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
